import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacypolicy.component.html',
    styleUrls: ['./privacypolicy.component.css'],
    standalone: false
})
export class PrivacypolicyComponent implements OnInit,AfterViewInit {
  isShow: boolean;
  topPosToStartShowing: number;

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    let el = document.querySelector('.toptoscroll');
    el.scrollIntoView({behavior:"smooth"});
  }
}
